import { useDraggable } from "@dnd-kit/core"
import { DragHandlerIcon } from "./dragHandlerIcon";
export const DraggableItem = ({item}) => {
    const {attributes, listeners, transform, setNodeRef} = useDraggable({
        id: item
    })

    const style = transform ? {
    transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
  } : undefined;

    return (
        <div 
            key={ item } 
            className="border rounded border-secondary p-2 m-1 d-flex justify-content-between align-items-center cursor-move gap-2"
            ref={setNodeRef}
            style={style} 
            {...listeners} {...attributes}
        >
            <p className="text-truncate m-0">{ item }</p>
            <DragHandlerIcon />
        </div>
    )
}